import { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';

export const useBidderCampaignTableOfContents = () => {
	const [isTableOfContents, setIsTableOfContents] = useState<boolean>(false);
	const location = useLocation();

	useEffect(() => {
		return () => setIsTableOfContents(false);
	}, [location]);

	return {
		isTableOfContents,
		tableOfContents: [
			{ id: 'basicInfo', element: 'Basic Info' },
			{ id: 'initialBids', element: 'New Domains' },
			{ id: 'newDomainsWithSale', element: 'New Domains With Sale' },
			// { id: 'dailyBudget', element: 'Daily Budget' },
			{ id: 'bidderDomainLimits', element: 'Publisher Domain Status Limit' },
			{ id: 'bidderTargetings', element: 'Targetings' },
			{ id: 'bidderBlackWhiteLists', element: 'Black/White Lists' },
		],
		setIsTableOfContents,
	};
};
